import React from 'react';
import PropTypes from 'prop-types';

import CategoryList from '../CategoryList';
import SubCategoryList from '../SubCategoryList';
import Wrap from './styled';

export default class Desktop extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            activeCategoryIndex: null,
        };
    }

    toggleSubCategories = (index) => {
        this.setState({ activeCategoryIndex: index });
    };

    handleMouseLeave = () => {
        const { closeMenu } = this.props;
        this.setState({ activeCategoryIndex: null });
        closeMenu();
    };

    renderSubCategories() {
        const { activeCategoryIndex } = this.state;
        const { categories } = this.props;
        if (activeCategoryIndex === null || !categories[activeCategoryIndex]) return null;
        return (
            <SubCategoryList
                parentCategoryPermalink={categories[activeCategoryIndex].permalink}
                subCategories={categories[activeCategoryIndex].children}
                closeMenu={this.handleMouseLeave}
            />
        );
    }

    render() {
        const { className, shouldShowMenu, categories, showMenu } = this.props;
        const { activeCategoryIndex } = this.state;
        return (
            <Wrap
                className={className}
                onMouseEnter={showMenu}
                onMouseLeave={this.handleMouseLeave}
                shouldShowMenu={shouldShowMenu}
            >
                <CategoryList
                    activeCategoryIndex={activeCategoryIndex}
                    categories={categories}
                    closeMenu={this.handleMouseLeave}
                    toggleSubCategories={this.toggleSubCategories}
                />
                {this.renderSubCategories()}
            </Wrap>
        );
    }
}

Desktop.propTypes = {
    shouldShowMenu: PropTypes.bool,
    className: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.object),
    showMenu: PropTypes.func,
    closeMenu: PropTypes.func,
};

Desktop.defaultProps = {
    shouldShowMenu: true,
    className: '',
    categories: [],
    closeMenu: () => {},
    showMenu: () => {},
};
